<template>
  <v-app>
    <navbar/>
    <v-main class="pa-2 main">
      <v-container>
        <router-view/>
      </v-container>
    </v-main>
    <rodape/>
    
  </v-app>
</template>

<script>
import Rodape from '@/components/Rodape.vue'
import Navbar from './components/navbar.vue'
import FrontendConfigService from '@/services/configs/frontendConfigService'

export default {
  name: 'App',
  components:{
    Navbar, Rodape
  },
  data: () => ({
  }),
  methods:{
    logout(){
      this.$store.loginStore.commit('encerrar')
      this.$router.history.push({name:'login'})
    },
  },
  computed:{
    computedUser(){
      return this.$store.loginStore.getters.getUserAthenticated
    },
    computedNotifications(){
        return this.$store.globalStore.getters.getNotifications
    }
  },
  created(){
  },
  watch:{
		computedNotifications:{
			handler(errors){
				for(let message of errors){
					let options = FrontendConfigService.getOptionsToast()
					//console.log(`${message.tag} - ${message.message} ${message.title}- ${options}`);
					this.$toast(message.message, {
						type: message.tag,
						...options
					})
				}
			}, deep:true
		}
  }
};
</script>

<style scoped>
.main{
  margin-top:70px;
}
</style>